export default {
  "agree-to-terms-and-conditions": {
    EN: "You must agree to the terms and conditions to create an account",
  },
  "email-verify-title": {
    EN: "Complete Sign Up",
  },
  "email-verify-failure-description": {
    EN: "Verification link invalid",
  },
  "signup-success": {
    EN: "Successfully signed up",
  },
  "signup-failure": {
    EN: "Failed to sign up",
  },
};
